import { render } from "./TourBookingSubmissionView.vue?vue&type=template&id=0a417e42"
import script from "./TourBookingSubmissionView.vue?vue&type=script&lang=js"
export * from "./TourBookingSubmissionView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__